import {
  RegisterForm,
} from '@/components';

export default {
  name: 'Register',
  components: {
    RegisterForm,
  },
};
